import React from 'react';
import './Best-practices-page.scss';
import BestPracticesBanner from "../../assets/img/Best_Practices.png"

function bestPractices(props) {
    return (
        <div className={'best-practices-page-wrapper'}>
            <section className={'section'}>
                {}
                <div className={'bestpractices-hero'}>
                    <img 
                        src={BestPracticesBanner} 
                        alt="FAQs Coming Soon"
                        className={'bestpractices-banner-img'} 
                    />
                </div>
            </section>
        </div>
    );
}

export default bestPractices;